export default class RulesAjax {
  constructor() {
    this.nav = document.querySelector('.tournament__subnav');
    this.content = document.querySelector('.tournament__about .tournament__content');

    if (!this.nav || !this.content) {
      this.nav = null;
      return;
    }

    this.links = [...this.nav.querySelectorAll('[data-rules-link]')];
    this.pushed = false;
    this.onClick = this.onClick.bind(this);
    this.onPop = this.onPop.bind(this);

    this.next = this.nav.querySelector('.tournament__subnav-next');
    this.onScroll = this.onScroll.bind(this);

    this.nav.addEventListener('click', this.onClick);
    this.nav.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('popstate', this.onPop);
    this.onScroll();
  }

  onScroll() {
    const { scrollLeft, scrollWidth, clientWidth } = this.nav;

    this.next.hidden = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  onClick(e) {
    if (e.target.closest('.tournament__subnav-next')) {
      this.nav.scrollBy({ left: this.nav.clientWidth * 0.6, behavior: 'smooth' });

      return;
    }

    const link = e.target.closest('[data-rules-link]');

    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) {
      return;
    }

    e.preventDefault();

    if (link.classList.contains('is-active')) {
      return;
    }

    this.load(link).then((ok) => {
      if (ok) {
        history.pushState(null, '', link.href);
        this.pushed = true;
      }
    });
  }

  onPop() {
    if (!this.pushed) {
      return;
    }

    this.load(this.links.find((link) => link.href === window.location.href) ?? this.links[0]);
  }

  async load(link) {
    const article = this.content.closest('.tournament__about');

    article.classList.add('is-loading');

    try {
      const response = await fetch(`${this.nav.dataset.rest}${link.dataset.id}?_fields=title,content`);
      const page = await response.json();

      if (!response.ok || !page.content) {
        throw new Error('rules');
      }

      const html = page.content.rendered;
      const heading = /^\s*<h[1-6]/i.test(html) ? '' : `<h2>${page.title.rendered}</h2>`;

      this.content.innerHTML = heading + html;
      this.links.forEach((item) => item.classList.toggle('is-active', item === link));

      return true;
    } catch {
      window.location.href = link.href;

      return false;
    } finally {
      article.classList.remove('is-loading');
    }
  }

  destroy() {
    if (!this.nav) {
      return;
    }

    this.nav.removeEventListener('click', this.onClick);
    this.nav.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('popstate', this.onPop);
  }
}
